// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__M4P6i"};